import { TranslateService } from "../../shared/translate/translate.service";
import { AuthService } from './../../shared/models/auth.service';
import { Component, ViewChild, OnInit, Output, EventEmitter } from "@angular/core";
import { Router } from '@angular/router';
import { TripCommentModel } from "./../models/tripcomment.model";
import { TripCommentService } from '../models/tripcomment.service';

@Component({
  selector: 'wego-tripcomment-popup',
  template: require('../views/tripcomment-popup.component.html'),
  providers: [TripCommentService]
})

export class TripCommentComponent implements OnInit {
  public isLoading: boolean;
  public errorMsg: string;
  public model: TripCommentModel = new TripCommentModel();
  
  public tripComment: string;
  public tripCommentBy: string;
  public tripCommentOn: string;
  public tripCommentByFullname: string;

  @ViewChild('tripCommentModal') public tripCommentModal: any;
  @Output('onCommentConfirm') onCommentConfirm = new EventEmitter();

  constructor(
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    private tripCommentService: TripCommentService
  ) {}

  ngOnInit() {
    this.model = new TripCommentModel();
  }

  public show(): void {
    this.tripCommentModal.show();
  }

  private AddTripComment() {
    const formData = new FormData();
    formData.append("tripcomment", JSON.stringify(this.model));

    this.tripCommentService.AddTripComment(formData).subscribe(
      res => {
        if (res.data) {
          this.OnSuccessSelect();
        } else {
          this.tripCommentModal.errorMsg = res.error;
        }
      },
      error => {
        console.log(error);
        this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  private OnSuccessSelect() {
    this.hide();
  }  
  
  public hide() {
    this.model = new TripCommentModel();
    this.errorMsg = "";
    this.tripCommentModal.hide();
  }

  public OnCancel($event: any) {
    this.hide();
  }  

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/tripdatareport/components/tripcomment-popup.component.ts